import { useRef, useState, useEffect } from "react";

export const useOverflowTooltip = (value) => {
  const ref = useRef();
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const isOverflowing =
      ref.current.scrollWidth > ref.current.clientWidth;

    setShowTooltip(isOverflowing);
  }, [value]);

  return { ref, showTooltip };
};
